var _circle, _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2994A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7517 25.6479L13.1517 22.0479C12.6825 21.5787 12.6825 20.8203 13.1517 20.3511C13.6209 19.8819 14.3793 19.8819 14.8485 20.3511L17.5317 23.0343L25.0893 14.4195C25.5213 13.9155 26.2785 13.8579 26.7801 14.2887C27.2841 14.7207 27.3429 15.4767 26.9109 15.9795L18.5109 25.5795C18.2937 25.8339 17.9793 25.9851 17.6457 25.9983C17.2821 25.9995 16.9761 25.8735 16.7517 25.6479Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7517 25.6479L13.1517 22.0479C12.6825 21.5787 12.6825 20.8203 13.1517 20.3511C13.6209 19.8819 14.3793 19.8819 14.8485 20.3511L17.5317 23.0343L25.0893 14.4195C25.5213 13.9155 26.2785 13.8579 26.7801 14.2887C27.2841 14.7207 27.3429 15.4767 26.9109 15.9795L18.5109 25.5795C18.2937 25.8339 17.9793 25.9851 17.6457 25.9983C17.2821 25.9995 16.9761 25.8735 16.7517 25.6479Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.e79628b5.svg";
export { ForwardRef as ReactComponent };